/**
 * Summary-band tiles — card 4311.
 *
 * `/admin` publishes three of the SAME figures the executive KPI row publishes, one band
 * below it. This module exists so the band cannot carry its own copy of the labels or the
 * formatters: a second `toFixed` here is exactly how one tier ends up with two different
 * numbers on one page (card 4512 is that defect on the revenue surface). `deriveSummaryTiles`
 * therefore takes the caller's `EXECUTIVE_KPI_DEFS` and reuses each key's OWN `format` —
 * one formatter per tile, never one parse for all three.
 *
 * The defs are passed IN rather than imported: they live in a `.jsx`, and jest here is
 * `testEnvironment: 'node'` with `transform: {}`, so importing them would make this module
 * unloadable by the suite. Taking them as a parameter keeps the derivation testable by
 * execution and keeps this file free of JSX.
 */

export const SUMMARY_TILE_KEYS = Object.freeze(['totalMembers', 'newMembers', 'grossRevenue']);

/** Rendered when a key has no def at all — an absent figure is never shown as a zero. */
export const MISSING_TILE_VALUE = '—';

export const findTileDef = (defs, key) =>
  (Array.isArray(defs) ? defs : []).find((def) => def?.key === key) ?? null;

export const deriveSummaryTiles = (defs, metrics) =>
  SUMMARY_TILE_KEYS.map((key) => {
    const def = findTileDef(defs, key);
    return {
      key,
      label: def?.label ?? key,
      value: typeof def?.format === 'function' ? def.format(metrics?.[key]) : MISSING_TILE_VALUE
    };
  });
